import React from 'react'
import sumBy from 'lodash/sumBy'

import WorkTrackerItem from './work-tracker-item'

export default ({
  workTrackers = [],
  finishedLoading,
}) => {
  const overallCompleted = sumBy(workTrackers, 'completed')
  const overallContractedCompleted = sumBy(workTrackers, 'contractedCompleted')
  const overallTotal = sumBy(workTrackers, 'total')

  if (workTrackers.length === 0) {
    return (
      <div>
        <p className='no-content'>{finishedLoading ? 'No work is being tracked.' : 'Loading...'}</p>
      </div>
    )
  }

  return (
    <div>
      <div className='work-tracker card'>
        <p className='service-name'><strong>Service(s)</strong></p>
        <p>
          <strong>
            (All) Current/Total Req.<br />
            <span className='small'>* All includes current and duplications</span>
          </strong>
        </p>
        <p className='last'><strong>Percentage<br /> Completed</strong></p>
      </div>
      <WorkTrackerItem workTracker={{
        serviceName: 'All Services',
        completed: overallCompleted,
        contractedCompleted: overallContractedCompleted,
        total: overallTotal
      }} />

      {workTrackers.map(workTracker =>
        <WorkTrackerItem workTracker={workTracker} key={workTracker.id} />
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-trackers-summary.js